<template>
  <div class="tips_container"
    @click="clickHandle">
    <i class="icon"></i>
    <span class="txt">我的订单</span>
  </div>
</template>

<script>
export default {
  name: 'ITips',
  methods: {
    clickHandle() {
      this.$emit('i-click');
    }
  }
};
</script>

<style scoped lang="stylus">
.tips_container {
  width 106px
  height 40px
  display flex
  padding-left 10px
  align-items center
  background-color #ffffff
  border-top-left-radius 20px
  border-bottom-left-radius 20px
  overflow hidden
  .icon {
    display block
    width 24px
    height 24px
    background url('./images/h5_payment_icon_my_ order@3x.png') center no-repeat
    background-size 24px 24px
    margin-right 4px
  }
  .txt {
    flex 1
    line-height 20px
    font-size 14px
    color #41414D
  }
}
</style>
